import { render, staticRenderFns } from "./table-cell-products.vue?vue&type=template&id=96e5cd9a&"
import script from "./table-cell-products.vue?vue&type=script&lang=js&"
export * from "./table-cell-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports